import { lazy } from 'react';

const RegionalsList = lazy(() => import('../pages'));

export const RegionalsRoutes = [
  {
    path: '',
    element: <RegionalsList />,
  }
];
